/*
 * @Author: wjl
 * @Date: 2020-04-26 20:19:15
 * @LastEditors: hxz
 * @LastEditTime: 2023-04-27 18:31:26
 * @FilePath: \appOfficial\src\router.js
 */
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/xieyi",
    name: "xieyi",
    component: () => import("@/views/Xieyi.vue"),
  },
  {
    path: "/yinsi",
    name: "yinsi",
    component: () => import("@/views/Yinsi.vue"),
  },
  {
    path: "/leader",
    name: "leader",
    component: () => import("@/views/leader.vue"),
  },
  {
    path: "/payMode",
    name: "payMode",
    component: () => import("@/views/PayMode.vue"),
  },
  {
    path: "/payIssue",
    name: "payIssue",
    component: () => import("@/views/PayIssue.vue"),
  },
  {
    path: "/synopsis",
    name: "synopsis",
    component: () => import("@/views/Synopsis.vue"),
  },
  {
    path: "/sdkPage",
    name: "sdkPage",
    component: () => import("@/views/SdkPage.vue"),
  },
  {
    path: "/brand",
    name: "brand",
    component: () => import("@/views/Brand.vue"),
  },
  {
    path: "/guide",
    name: "guide",
    component: () => import("@/views/Guide.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});

export default router;
